import { type SapAdapterRouter } from '@backend-types/AppRouter';
import { QueryClient } from '@tanstack/react-query';
import { httpLink, loggerLink } from '@trpc/client';
import { createTRPCReact } from '@trpc/react-query';
import superjson from 'superjson';
import { v7 } from 'uuid';

const trpc = createTRPCReact<SapAdapterRouter>();

const trpcClient = (getToken: () => Promise<string | null>, appBackendUrl: string) =>
  trpc.createClient({
    links: [
      loggerLink(),
      httpLink({
        transformer: superjson,
        url: appBackendUrl,
        async headers() {
          const xVivaRequestId = v7();

          const authToken = await getToken();

          return {
            Authorization: `Bearer ${authToken}`,
            'X-Viva-Request-Id': xVivaRequestId,
          };
        },
        async fetch(url, options) {
          return await fetch(url, {
            ...options,
            credentials: 'include',
          });
        },
      }),
    ],
  });

const queryClient = new QueryClient();

export { queryClient, trpc, trpcClient };
